import { render, staticRenderFns } from "./Mappa.vue?vue&type=template&id=9bfa6ff0&"
import script from "./Mappa.vue?vue&type=script&lang=js&"
export * from "./Mappa.vue?vue&type=script&lang=js&"
import style0 from "./Mappa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports